import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";
import { AxiosError } from "axios";


export async function postBlackBaudTransaction(transactionData: any) {
  try {
    const blackBaudTransactionResponse = await axiosInterceptor.post(`${environment.postReProcessBlackBaudTransactionURL}${transactionData}`, null);
    return blackBaudTransactionResponse;
 } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBlackBaudDetailsBytransactionDateAndClientId(transactionDate: any, clientId: number) {
  try {
    const blackBaudTransactionResponse = await axiosInterceptor.get(`${environment.getBlackBaudDetailsByEventTypeAndInternalIdURL}${transactionDate}&clientId=${clientId}`);
    return blackBaudTransactionResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}